import React from 'react';

type Props = {
  className?: string;
  totalWishlistItems: number;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <>
    {/* {totalWishlistItems > 0 && (
      <span className="absolute right-[-8px] top-[-6px] block h-[15px] min-w-[15px] rounded-full bg-[#dc143c] pl-[2px] pr-[2px] text-center text-[9px] font-semibold leading-[15px] text-white" />
    )} */}
    {/* <HeartIcon className={className} /> */}
    <i className={`${className} icon icon-heart-header`}></i>
  </>
);

export default Icon;
